"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TeamboardModel = void 0;
const DataType_1 = __importDefault(require("@opsbase/lib-datatype/DataType"));
const lib_i18n_1 = __importDefault(require("@opsbase/lib-i18n"));
const SetupStatus_1 = __importDefault(require("@opsbase/lib-teamboard/SetupStatus"));
const capitalize_1 = __importDefault(require("lodash/capitalize"));
const moment_timezone_1 = __importDefault(require("moment-timezone"));
const Model_1 = __importDefault(require("../Model"));
const ModelRegistry_1 = __importDefault(require("../ModelRegistry"));
class TeamboardModel extends Model_1.default {
    constructor(o) {
        super(o);
        this.title = '';
        this.place = undefined;
        this.teams = [];
        this.allTeams = false;
        this.locked = false;
        this.securityKey = '';
        this.selfieRequired = false;
        this.showStaffIssues = false;
        super.init(o);
    }
    get __typename() {
        return 'Teamboard';
    }
    set __typename(v) {
    }
    get teamsText() {
        return this.teams.length > 1
            ? `${this.teams[0].title} +${this.teams.length - 1}`
            : this.teams.length === 1
                ? this.teams[0].title
                : lib_i18n_1.default.t('all-teams');
    }
    get placeText() {
        return this.place ? this.place.title : '----------------';
    }
    get securityBits() {
        return [
            this.securityKey.substr(0, 3),
            this.securityKey.substr(3, 3),
            this.securityKey.substr(6, 3),
        ];
    }
    get securityKeyNice() {
        return this.securityBits.join(' - ');
    }
    get isSetup() {
        return this.setupStatus === SetupStatus_1.default.SETUP;
    }
    get lastAccessedText() {
        return this.isSetup
            ? (0, capitalize_1.default)(`${moment_timezone_1.default
                .duration((0, moment_timezone_1.default)().diff(this.lastAccessed, 'milliseconds'), 'milliseconds')
                .humanize()} ago`)
            : lib_i18n_1.default.t('awaiting-setup');
    }
}
exports.TeamboardModel = TeamboardModel;
TeamboardModel.ALL_FIELDS = `id, title, lastAccessed, securityKey, preferences, locked,setupStatus,allTeams,
		place { id, title, timezone }, selfieRequired,showStaffIssues,
		teams { id, title }`;
exports.default = TeamboardModel;
ModelRegistry_1.default[DataType_1.default.TEAMBOARD] = TeamboardModel;
